import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './GroupContent.module.css';

type GroupContentProps = HTMLAttributes<HTMLDivElement>;

const GroupContent: FC<GroupContentProps> = ({ className, ...props }) => (
  <div className={clsx(s.content, className)} {...props} />
);

export { GroupContent };
